import { render, staticRenderFns } from "./CustomerDebitStatement.vue?vue&type=template&id=808c0364&"
import script from "./CustomerDebitStatement.vue?vue&type=script&lang=js&"
export * from "./CustomerDebitStatement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports